import { cn } from "@commerce-frontend/ui/helpers/styles";
import type { Options } from "react-markdown";

// TODO: Move to reusable base component
export const FormDescription = ({ className, children, ...props }: Options & { id: string }) => (
	<div className={cn("text-md font-normal text-gray-500", className)} {...props}>
		{children}
	</div>
);
